export const PREDICTION_OTHERS_LIST = [
  {value: "no_link", label: "Do Nothing"},
  {value: "any_link", label: "Any Link"},
];


